import RestService from './RestService'

export default class CollaboratorService extends RestService {
    constructor() {
        super('collaborators')
    }

}